import BlockchainAddress from './BlockchainAddress';

export default BlockchainAddress;
